import React from 'react';
import LegalPageLayout from '../components/LegalPageLayout';

const DataDestructionPolicyPage = () => (
  <LegalPageLayout title="Data Destruction Policy">
    <p className="text-white/60 text-sm">Last updated: {new Date().toLocaleDateString('en-US')}</p>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">1. Overview</h2>
      <p>
        Dial-Grid is committed to securely handling and disposing of your data when it is no longer needed. This Data Destruction Policy describes how we delete or destroy data upon account termination, request, or when retention periods expire.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">2. When Data Is Destroyed</h2>
      <p>We destroy or irreversibly anonymize data in the following circumstances:</p>
      <ul className="list-disc pl-6 mt-2 space-y-1">
        <li><strong>Account closure:</strong> Upon your request to close your account, we will delete your personal data and business data within 30 days, except where we must retain data for legal, regulatory, or legitimate business purposes.</li>
        <li><strong>Termination for cause:</strong> If we terminate your account for policy violations, we may retain data as needed for enforcement or legal proceedings.</li>
        <li><strong>Retention expiry:</strong> Backup and log data are purged according to our retention schedule (typically 90 days to 1 year, depending on data type).</li>
      </ul>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">3. Destruction Methods</h2>
      <p>
        We use industry-standard methods to ensure data cannot be recovered: secure deletion (overwriting) for storage media, cryptographic erasure where applicable, and physical destruction of decommissioned hardware. Third-party processors are contractually required to follow equivalent practices.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">4. Data We May Retain</h2>
      <p>
        We may retain certain data after account closure when required by law (e.g., tax records, transaction history for regulatory compliance), for dispute resolution, or to enforce our terms. Such data is kept only as long as necessary and is not used for marketing or other purposes.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">5. Your Rights</h2>
      <p>
        You may request deletion of your data at any time by contacting us. We will process requests in accordance with applicable law and this policy. Export of your data is available before deletion upon request.
      </p>
    </section>

    <section>
      <h2 className="text-xl font-semibold text-white mt-8 mb-3">6. Contact</h2>
      <p>
        For data deletion requests or questions about this policy, contact us at privacy@dial-grid.com.
      </p>
    </section>
  </LegalPageLayout>
);

export default DataDestructionPolicyPage;
